/**
 * UX zones - must stay in sync with App\Enums\UserZoneEnum.
 *
 * A zone is a coarse-grained area of the app (sidebar layout + routes).
 * Several roles can map into the same zone - adding new roles in the future
 * (carEnthusiast → Profile, influencer → Studio) only requires updating
 * `UserRoleEnum::zone()` on the backend; the frontend consumes zones, not roles.
 */
export const ZONES = Object.freeze({
    PROFILE: 'profile',
    STUDIO: 'studio',
    ADMIN: 'admin',
})

/**
 * Landing path + display copy per zone. Mirrors `UserZoneEnum::getLandingPath()`
 * and `getTagline()` - keep in lockstep.
 *
 * `label` is short on purpose ("Profil" not "Přepnout do Profilu") so the
 * sidebar switcher card lays out on one line even at narrow widths. The full
 * "switch into X" semantic lives in the consuming component's `aria-label`.
 */
export const ZONE_META = Object.freeze({
    [ZONES.PROFILE]: {
        label: 'Profil',
        tagline: 'Moje fotky, garáž, objednávky',
        icon: 'person',
        href: '/profil/fotky',
    },
    [ZONES.STUDIO]: {
        label: 'Studio',
        tagline: 'Spravuj své galerie a fotky',
        icon: 'photo_camera',
        href: '/studio/nastenka',
    },
    [ZONES.ADMIN]: {
        label: 'Admin',
        tagline: 'Spravuj lokace, uživatele a obsah',
        icon: 'shield_person',
        href: '/dashboard',
    },
})
